import { RootState } from '~/store/rootReducer';

export const loginSelector = {
  user: (state: RootState) => state.auth.user,
  loading: (state: RootState) => state.auth.loading,
  isAuth: (state: RootState) => state.auth?.isAuth,
};
